import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideSectionLabel,
  GuideBlockList,
} from "../GuideBlocks.js";

const ThinkingFrameworksSection = ({ heading, accentIndex = 2, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="thinking-frameworks"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Our minds naturally create stories. This is normal. The problem begins when we mistake those
      stories for reality.
    </GuideLead>
    <p className="guide-panel__p">
      A thinking framework helps interrupt this automatic process. Whenever you notice yourself
      overthinking, ask:
    </p>
    <GuideSectionLabel>Five questions to escape the story</GuideSectionLabel>
    <GuideBlockList
      items={[
        "What actually happened?",
        "What story am I telling myself?",
        "What evidence supports this story?",
        "Is there another explanation?",
        "What response aligns with the evidence?",
      ]}
    />
    <p className="guide-panel__p">
      These simple questions prevent your mind from becoming trapped in assumptions. Instead of
      believing every thought, you learn to examine it.
    </p>
    <GuideCallout>
      Over time, this becomes a habit that strengthens response discipline and decision quality.
    </GuideCallout>
  </GuidePanel>
);

export default ThinkingFrameworksSection;
